import UserDetails from './components/screens/users/user-details.vue';
import ChangeEmail from './components/screens/auth/change-email.vue';
import ChangePassword from './components/screens/auth/change-password.vue';
import UserActivity from './components/screens/users/user-activity.vue';

export default store => ([
  {
    path: '/',
    name: 'home',
    redirect: () => {
      if (!store.getters.isLoggedIn) {
        return { name: 'login' };
      }

      if (store.getters.isAdmin && !store.getters.account) {
        return { name: 'admin' };
      }
      return { name: 'account.dashboard', params: { accountName: store.getters.account.name } };
    },
  },
  {
    path: '/accounts/:accountName',
    name: 'account',
    component: () => import('./components/screens/account/account.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/dashboard',
    name: 'account.dashboard',
    component: () => import('./components/screens/dashboard/dashboard.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/rag',
    name: 'account.rag',
    component: () => import('./components/screens/rag-view/rag-view.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/list',
    name: 'account.list',
    component: () => import('./components/screens/list-view/list-view.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/detail',
    name: 'account.detail',
    component: () => import('./components/screens/graphs/graph-view.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/graph',
    name: 'account.graph',
    component: () => import('./components/screens/graphs/multi-graph-view.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/alarm',
    name: 'account.alarm',
    component: () => import('./components/screens/alarms/alarm-view.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/audit',
    name: 'account.audit',
    component: () => import('./components/screens/audit-log/audit-trail.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/users',
    name: 'account.users',
    component: () => import('./components/screens/users/users.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/users/create',
    name: 'account.users.create',
    component: () => import('./components/screens/users/user-create.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/users/:userId',
    name: 'account.user',
    component: () => import('./components/screens/users/user.vue'),
    props: route => ({ ...route.params, userId: parseInt(route.params.userId, 10) }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/locations',
    name: 'account.locations',
    component: () => import('./components/screens/locations/locations.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/groups',
    name: 'account.groups',
    component: () => import('./components/screens/groups/groups.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/devices',
    name: 'account.devices',
    component: () => import('./components/screens/devices/devices.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/devices/create',
    name: 'account.devices.create',
    component: () => import('./components/screens/devices/device-create.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/devices/:deviceId',
    name: 'account.device',
    component: () => import('./components/screens/devices/device-details.vue'),
    props: route => ({ ...route.params, deviceId: parseInt(route.params.deviceId, 10) }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/accounts/:accountName/license',
    name: 'account.license',
    component: () => import('./components/screens/account/account-license.vue'),
    props: route => ({ ...route.params, accountName: store.getters.account.name }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: {
      template: '<div>admin page</div>',
    },
    meta: {
      auth: true,
      comarkAdmin: true,
    },
  },
  {
    path: '/admin/firmware',
    name: 'admin.firmware',
    component: () => import('./components/screens/firmware/firmware.vue'),
    props: route => ({ ...route.params }),
    meta: {
      auth: true,
      comarkAdmin: true,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: UserDetails,
    props: () => ({ accountName: store.getters.account.name, userId: store.getters.user.id }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/profile/change-password',
    name: 'profile.password',
    component: ChangePassword,
    props: () => ({ accountName: store.getters.account.name, userId: store.getters.user.id }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/profile/change-email',
    name: 'profile.email',
    component: ChangeEmail,
    props: () => ({ accountName: store.getters.account.name, userId: store.getters.user.id }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/profile/activity',
    name: 'profile.activity',
    component: UserActivity,
    props: () => ({ accountName: store.getters.account.name, userId: store.getters.user.id }),
    meta: {
      auth: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('./components/screens/account/register.vue'),
    meta: {
      auth: false,
      providesOwnLayout: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./components/screens/auth/login.vue'),
    props: true,
    meta: {
      auth: false,
      providesOwnLayout: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('./components/screens/auth/forgot-password.vue'),
    props: true,
    meta: {
      auth: false,
      providesOwnLayout: true,
    },
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () => import('./components/screens/auth/reset-password.vue'),
    props: true,
    meta: {
      auth: false,
      providesOwnLayout: true,
    },
  },
  {
    path: '/email-verify',
    name: 'email-verify',
    component: () => import('./components/screens/auth/email-verify.vue'),
    props: true,
    meta: {
      auth: false,
      providesOwnLayout: true,
    },
  },
  {
    path: '*',
    name: '404',
    component: () => import('./components/screens/404.vue'),
    meta: {
      providesOwnLayout: true,
    },
  },
]);
